import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';

const ERROR_KEYS = {
  MSG_INVALID_CODE: 'INVALID_CODE',
  CODE_INVALID_CODE: '507'
};

@Component({
  selector: 'app-device-init-code',
  templateUrl: './device-init-code.component.html',
  styleUrls: ['./device-init-code.component.scss']
})
export class DeviceInitCodeComponent implements OnInit {

  inputGroupOption = {
    input: {
      label: 'DEVICE_CODE_FLOW.CODE_INIT.CODE_PLACEHOLDER',
      placeholder: '',
      hint: '',
      value: '',
      type: 'input',
    },
    button: {
      text: 'NEXT',
      color: 'accent',
      showImg: false
    },
  };
  buttonOptions: any = {
    backToLogin: {
      color: 'accent',
      text: 'BACK_TO_LOGIN',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  };
  userCode = '';
  errorMessage = '';
  contentLoading: boolean = false;
  verifyInProgress = false;
  constructor(private cidaas: CidaasService, private route: ActivatedRoute,
              public commonFunc: CommonFunctionsService) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    if (params.get('error_code') === ERROR_KEYS.CODE_INVALID_CODE) {
      this.errorMessage = ERROR_KEYS.MSG_INVALID_CODE;
    }
  }


  submit(): void {
    if (!this.userCode || this.userCode.length === 0) {
      this.errorMessage = ERROR_KEYS.MSG_INVALID_CODE;
      return;
    }
    // this.router.navigate(['device_code_success']);
    this.verifyInProgress = true;
    try {
      this.cidaas._deviceCodeVerify(this.userCode);
    } catch (e) {
      this.verifyInProgress = false;
    }
  }
}
